// sorteio-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "* Os sorteios devem ser registrados na Caixa Econômica Federal e o registro é de responsabilidade do cliente.": "* Los sorteos deben registrarse en la Caixa Econômica Federal y el registro es responsabilidad del cliente.",
    ", sempre com": ", siempre con",
    ". Atribuídos a clientes:": ". Asignados a clientes:",
    ". Participantes:": ". Participantes:",
    ". Total de números:": ". Total de números:",
    "Acumulado": "Acumulado",
    "Arquivado": "Archivado",
    "As regras deste sorteio ficam no Clube de Vantagens": "Las reglas de este sorteo se encuentran en el Club de Beneficios",
    "Criar Sorteio": "Crear Sorteo",
    "Dados arquivados em": "Datos archivados el",
    "Data do sorteio": "Fecha del sorteo",
    "Data e hora do sorteio": "Fecha y hora del sorteo",
    "Detalhes do sorteio": "Detalles del sorteo",
    "Editar Sorteio": "Editar Sorteo",
    "Esta rede está com o Clube de Vantagens desligado": "Esta red tiene el Club de Beneficios desactivado",
    "Nenhum": "Ninguno",
    "Não pode ser alterado: trocar depois deixaria regra órfã ou faria o sorteio conceder número duas vezes.": "No se puede modificar: cambiarlo después dejaría la regla huérfana o haría que el sorteo otorgue el número dos veces.",
    "Número Sorteado": "Número Sorteado",
    "Número final": "Número final",
    "Número inicial": "Número inicial",
    "Números": "Números",
    "Números da Sorte": "Números de la Suerte",
    "O limite máximo é de 10.000.000 de números da sorte.": "El límite máximo es de 10.000.000 de números de la suerte.",
    "Ocorreu um erro ao gerar os números da sorte.": "Ocurrió un error al generar los números de la suerte.",
    "Os dados detalhados dos números da sorte são mantidos por até 1 ano após a data do sorteio.": "Los datos detallados de los números de la suerte se mantienen hasta 1 año después de la fecha del sorteo.",
    "Os números da sorte estão sendo gerados. Isso pode levar alguns minutos.": "Los números de la suerte se están generando. Esto puede tardar algunos minutos.",
    "Postos (Opcional)": "Estaciones (Opcional)",
    "Quantidade de cupons": "Cantidad de cupones",
    "Regeneração dos números da sorte iniciada.": "Regeneración de los números de la suerte iniciada.",
    "Regra": "Regla",
    "Regra ativada": "Regla activada",
    "Regras do sorteio": "Reglas del sorteo",
    "Regras via Clube de Vantagens": "Reglas vía Club de Beneficios",
    "Se esta opção estiver ativada, o cliente ganhará os números levando em conta todos os abastecimentos do perído do sorteio.": "Si esta opción está activada, el cliente ganará los números considerando todas las cargas de combustible del período del sorteo.",
    "Sem o Clube não há onde cadastrar a regra do número da sorte, e o sorteio não concederia número nenhum. Habilite o módulo na rede antes de criar o sorteio.": "Sin el Club no hay dónde registrar la regla del número de la suerte, y el sorteo no otorgaría ningún número. Habilite el módulo en la red antes de crear el sorteo.",
    "Serão gerados": "Se generarán",
    "Sorteio no modelo antigo": "Sorteo en el modelo antiguo",
    "Sorteios criados antes desta mudança": "Sorteos creados antes de este cambio",
    "Tipo do valor": "Tipo de valor",
    "Url do regulamento": "Url del reglamento",
    "Valor em pontos": "Valor en puntos",
    "Vencedor": "Ganador",
    "Você pode indicar quais postos serão abrangidos pela regra. Se deixar em branco, todos os postos serão considerados válidos.": "Puede indicar qué estaciones estarán incluidas en la regla. Si lo deja en blanco, se considerarán válidas todas las estaciones.",
    "até": "hasta",
    "compra na loja": "compra en la tienda",
    "dígitos": "dígitos",
    "gerados)": "generados)",
    "números de": "números de",
};

export default catalogo;
